import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  // Existing styles
  image: {
    width: '100%',
    height: 'auto',
    maxHeight: '70vh',
    objectFit: 'contain',
  },
  // New styles for video
  videoContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  video: {
    width: '100%',
    maxHeight: '70vh',
  },
  // New styles for audio
  audioContainer: {
    width: '100%',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '300px',
    maxWidth: '600px',
    margin: '0 auto',
  },
  audio: {
    width: '100%',
    height: '50px',
  },
  // Zoom controls
  zoomControls: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1000,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0.5),
    display: 'flex',
    gap: theme.spacing(0.5),
    '& .MuiIconButton-root': {
      backgroundColor: '#fff',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
  },
}))
